var map = {
	"./en/common.json": [
		743,
		157
	],
	"./en/kiddie.json": [
		744,
		156
	],
	"./en/middle.json": [
		745,
		155
	],
	"./en/teacher.json": [
		746,
		154
	],
	"./es-MX/common.json": [
		747,
		153
	],
	"./es-MX/kiddie.json": [
		748,
		152
	],
	"./es-MX/middle.json": [
		749,
		151
	],
	"./es-MX/teacher.json": [
		750,
		150
	],
	"./pt-BR/common.json": [
		751,
		149
	],
	"./pt-BR/kiddie.json": [
		752,
		148
	],
	"./pt-BR/middle.json": [
		753,
		147
	],
	"./pt-BR/teacher.json": [
		754,
		146
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 142;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/config/locales lazy ^\.\/.*\.json$
// module id = 142
// module chunks = 162